export enum OccupancyAllowanceType {
    Adults,
    Kids
}
